import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import Swiper from 'swiper';

import { slidesOptionsImages } from '../../models/Constants';
import { StorageData } from '../../services/utilities/storage-data.class';

@Component({
  selector: 'app-overlay',
  templateUrl: './overlay.page.html',
  styleUrls: ['./overlay.page.scss'],
})
export class OverlayPage implements OnInit, AfterViewInit, OnDestroy {

  @Input() keyStorage: string = '';
  @Input() otherParameters?: any
  @Input() slide = false;

  @ViewChild('swiperOverlay') swiperContainer: ElementRef | undefined;

  public swiperInstance: HTMLElement & { swiper: Swiper } | undefined;
  public slidesOptions = slidesOptionsImages;

  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    if (this.swiperContainer?.nativeElement) {
      this.swiperInstance = this.swiperContainer.nativeElement as HTMLElement & { swiper: Swiper };
      Object.assign(this.swiperInstance, this.slidesOptions);
    }
  }

  ngOnDestroy() {
    if (this.swiperInstance) {
      this.swiperInstance.swiper.destroy();
    }
  }

  public onDismiss(agreed: boolean) {
    if (this.keyStorage && agreed) {
      const dataStorage = { firstTime: 1, FechaEdicion: this.otherParameters.FechaEdicion }
      StorageData.setDataStorage(this.keyStorage, dataStorage)
    }
    this.modalCtrl.dismiss(true)
  }

  public slideDismiss = async (index: number) => {
    if (this.otherParameters.length === index + 1) {
      const dataStorage = { firstTime: 1, FechaEdicion: this.otherParameters[0].FechaEdicion }
      StorageData.setDataStorage(this.keyStorage, dataStorage)
      this.modalCtrl.dismiss(true)
    } else if (this.swiperInstance) {
      this.swiperInstance.swiper.update();
      this.swiperInstance.swiper.slideTo(index + 1);
    }
  }

}
